<template>
  <a-modal v-model="visible" :title="$t('字典内容')" :width="1000" destroyOnClose :footer="null">
    <a-card>
      <a-button type="primary" @click="handleAdd">{{ $t('新增') }}</a-button>
      <a-table rowKey="id" :pagination="pagination" :columns="columns" :dataSource="dataSource" @change="handleTableChange">
        <div slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{ $t('编辑') }}</a>    
          <a-divider type="vertical" />
          <a-popconfirm :title="$t('确认删除吗？')" @confirm="handleDelete(record)">
            <a style="color: red;">{{ $t('删除') }}</a>
          </a-popconfirm>
        </div>
      </a-table>
    </a-card>
    <DictContentEditModal ref="edit" @ok="handleRefresh" />
  </a-modal>
</template>
<script>
import { getDictContentList, removeDictContent } from '@/api/system/dict'
import DictContentEditModal from './DictContentEditModal.vue'

export default {
  components: {
    DictContentEditModal
  },
  data() {
    return {
      visible: false,
      queryParams: {},
      dict: {},
      dataSource: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showTotal: total => this.$t('共n条数据', [total])
      },
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('字典名称'),
          dataIndex: 'dictName',
        },
        {
          title: this.$t('字典编码'),
          dataIndex: 'dictCode',
        },
        {
          title: this.$t('内容'),
          dataIndex: 'label',
        },
        {
          title: this.$t('内容英文'),
          dataIndex: 'labelEn',
        },
        {
          title: this.$t('值'),
          dataIndex: 'dictValue',
        },
        {
          title: this.$t('备注'),
          dataIndex: 'remark',
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          width: 200,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    show(dict) {
      this.pagination.current = 1
      this.pagination.total = 0
      this.queryParams = {}
      this.dataSource = []
      this.dict = { ...dict }
      this.handleRefresh()
      this.visible = true
    },
    handleRefresh(toFirstPage = false) {
      this.loadTableData({ pageNum: toFirstPage ? 1 : this.pagination.current, pageSize: this.pagination.pageSize, ...this.queryParams })
    },
    handleTableChange(page) {
      if (page.current == this.pagination.current) {
        return
      }
      this.loadTableData({ pageNum: page.current, pageSize: page.pageSize, ...this.queryParams })
    },
    loadTableData(params) {
      getDictContentList({ ...params, dictId: this.dict.id }).then(res => {
        if (res.code === 0) {
          this.pagination.current = res.data.pageNum
          this.pagination.total = res.data.total
          this.dataSource = res.data.items
        } else {
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      })
    },
    handleAdd() {
      this.$refs.edit.show({ dictName: this.dict.name, dictCode: this.dict.code, dictId: this.dict.id, appId: this.dict.appId })
    },
    handleEdit(record) {
      this.$refs.edit.show(record)
    },
    handleDelete(record) {
      removeDictContent([record.id]).then(res => {
        if (res.code === 0) {
          this.handleRefresh()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>